import React, { FunctionComponent } from 'react';
import type { TermsSection } from '../../../types/recruitmentTerms';
import classnames from 'classnames';

type Props = {
  sections: TermsSection[];
};

export const Presentation: FunctionComponent<Props> = ({
  sections,
}) => {
  return (
    <div className="l-articles js-background-fixed">
      <div className="l-terms-inner u-clear">
        <h1 className="articles-title">求人・転職情報</h1>
        <main className="l-articles-main terms-container">

          <div className="terms-box">
            {sections.map((section, si) => (
              <div className="terms-inner" key={si}>
                <div className="terms-title">
                  {section.title}
                  {section.groups.map((group, gi) => (
                    <nav
                      className={classnames({
                        'terms-tab-parent': group.type === 'parent',
                        'terms-tab': group.type !== 'parent',
                      })}
                      key={gi}
                    >
                      {group.links.map((link, li) => (
                        <a
                          href={link.url}
                          className={classnames({
                            'terms-tab-parent-word': group.type === 'parent',
                            'terms-tab-word': group.type !== 'parent',
                          })}
                          key={li}
                        >
                          {link.label}
                        </a>
                      ))}
                    </nav>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </main>
      </div>
    </div>
  );
};
